export interface CarNumberIdentity {
  car_number?: string | null;
  enrollment_id: number;
}

/** Organizer-assigned race number, falling back to the stable enrollment id. */
export function displayCarNumber(identity: CarNumberIdentity): string {
  const assigned = identity.car_number?.trim();
  return assigned || String(identity.enrollment_id);
}

/** Natural order keeps 2 before 10 and handles suffixes such as 12A. */
export function compareCarNumbers(a: CarNumberIdentity, b: CarNumberIdentity): number {
  return displayCarNumber(a).localeCompare(displayCarNumber(b), undefined, {
    numeric: true,
    sensitivity: 'base',
  });
}
